module.exports = __webpack_public_path__ + "static/media/Search.687377d4.svg";